export default __webpack_public_path__ + "static/media/lampLivingroomOn.0937fdf5.png";